exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-render .ant-form-item-label label{min-width:85px;display:inline-block;vertical-align:middle;text-align:left;word-break:break-all!important;white-space:normal;line-height:14px}.field-render .ant-form-item-children{display:block}", ""]);

// exports
